import type { ComponentType } from 'react';
import type { BoxProps } from '@mui/material/Box';
import type { GridRenderCellParams, GridValidRowModel, GridStateColDef } from '@mui/x-data-grid';

interface GridRenderCellParamsWithProps<TProps, V = string, R extends GridValidRowModel = {}, F = V> extends GridRenderCellParams<V, R, F> {
    readonly colDef: GridStateColDef & {
        readonly props?: TProps;
    };
}

const withGridCellParams = <
    V = string,
    R extends GridValidRowModel = {},
    F = V,
    TProps = BoxProps
>(WrappedComponent: ComponentType<GridRenderCellParamsWithProps<TProps, V, R, F>>) =>
    (gridCellProps: GridRenderCellParamsWithProps<TProps, V, R, F>) => (
        <WrappedComponent
            {...gridCellProps}
            colDef={gridCellProps.colDef}
        />
    );

export default withGridCellParams;
